/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

import PropTypes from 'prop-types'; // eslint-disable-line no-unused-vars
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import { FormHelpBlock, LabelWithRequired, joinDataTestId } from '@motili/ui';
import { getValidationState } from 'common/utils/validation-utils';

FormTextArea.propTypes = {
    label: PropTypes.string,
    style: PropTypes.object,
    inputStyle: PropTypes.object,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    validation: PropTypes.shape({
        state: PropTypes.oneOf(['error', 'warning', 'success']),
        message: PropTypes.string,
    }),
    controlId: PropTypes.string.isRequired,
    value: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    maxLength: PropTypes.string,
    dataTestId: PropTypes.string,
};

export default function FormTextArea({
    style = {},
    inputStyle = {},
    controlId = 'form-textarea',
    validation = {},
    maxLength = '',
    label,
    required,
    value,
    disabled,
    placeholder,
    onChange,
    onBlur,
    dataTestId,
}) {
    const { isInvalid, isValid, isWarning } = getValidationState(validation);

    return (
        <Form.Group controlId={controlId} style={style}>
            {label && (
                <LabelWithRequired required={required} dataTestId={dataTestId}>
                    {label}
                </LabelWithRequired>
            )}
            <FormControl
                style={inputStyle}
                as='textarea'
                value={value}
                disabled={disabled}
                placeholder={placeholder}
                onChange={onChange}
                onBlur={onBlur}
                maxLength={maxLength}
                isValid={isValid}
                isInvalid={isInvalid}
                data-test-id={joinDataTestId([dataTestId, 'input'])}
            />
            {isInvalid && (
                <FormHelpBlock>{validation.message || 'Invalid'}</FormHelpBlock>
            )}
            {isWarning && (
                <FormHelpBlock>{validation.message || 'Warning'}</FormHelpBlock>
            )}
        </Form.Group>
    );
}
